var map = {
	"./decidim/avatar-multiuser.png": 81346,
	"./decidim/brands/google.svg": 26861,
	"./decidim/cc-badge.png": 63900,
	"./decidim/decidim-logo.svg": 22000,
	"./decidim/default-avatar.svg": 24936,
	"./decidim/gamification/badges/decidim_gamification_badges_followers.svg": 58804,
	"./decidim/icons.svg": 56707,
	"./decidim/pattern.png": 46996,
	"./decidim/placeholder-card-g.svg": 5569,
	"./decidim/placeholder-card-l.svg": 43338,
	"./decidim/placeholder.jpg": 66969,
	"./decidim/remixicon.symbol.svg": 4781,
	"./decidim/vendor/leaflet/layers-2x.png": 47052,
	"./decidim/vendor/leaflet/layers.png": 43355,
	"./decidim/vendor/leaflet/marker-icon-2x.png": 86518,
	"./decidim/vendor/leaflet/marker-icon.png": 44973,
	"./decidim/vendor/leaflet/marker-shadow.png": 15298,
	"./decidim/vendor/social-share-button/douban.svg": 7228,
	"./decidim/vendor/social-share-button/email.svg": 11705,
	"./decidim/vendor/social-share-button/facebook.svg": 31055,
	"./decidim/vendor/social-share-button/google_bookmark.svg": 39153,
	"./decidim/vendor/social-share-button/hacker_news.svg": 51673,
	"./decidim/vendor/social-share-button/linkedin.svg": 14617,
	"./decidim/vendor/social-share-button/odnoklassniki.svg": 93114,
	"./decidim/vendor/social-share-button/pinterest.svg": 97887,
	"./decidim/vendor/social-share-button/reddit.svg": 31235,
	"./decidim/vendor/social-share-button/telegram.svg": 40566,
	"./decidim/vendor/social-share-button/tumblr.svg": 98114,
	"./decidim/vendor/social-share-button/twitter.svg": 5096,
	"./decidim/vendor/social-share-button/vkontakte.svg": 17350,
	"./decidim/vendor/social-share-button/wechat.svg": 92993,
	"./decidim/vendor/social-share-button/whatsapp.svg": 43177,
	"./decidim/vendor/social-share-button/x.svg": 92065,
	"./decidim/vendor/social-share-button/xing.svg": 19119
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 79171;